// extracted by mini-css-extract-plugin
export var root = "styles-module--root--2kx1R";
export var open = "styles-module--open--2S5Qu";
export var modalTitle = "styles-module--modalTitle--1J-nx";
export var svg = "styles-module--svg--LhbN8";